import api from '../BaseUrl';
import { Experience } from '../Client/PublicResponse';

export type { Experience };

export const getExperience = async (): Promise<Experience[]> => {
  const res = await api.get<Experience[]>('/api/WorkExperience/GetWork');
  return res.data;
};

export const postExperience = async (data: Omit<Experience, 'id'>): Promise<void> => {
  await api.post('/api/Admin/AddWorkExperience', data);
};

export const putExperience = async (id: string | number, data: Omit<Experience, 'id'>): Promise<void> => {
  await api.put(`/api/Admin/UpdateWorkExperience/${id}`, data);
};

export const deleteExperience = async (id: string | number): Promise<void> => {
  await api.delete(`/api/Admin/DeleteWorkExperience/${id}`);
};
